import AgentsAPI from 'dashboard/api/agents/agents';
import { throwErrorMessage } from 'dashboard/store/utils/api';

const SET_INBOXES = 'SET_AI_INBOXES';
const SET_AVAILABLE_INBOXES = 'SET_AI_AVAILABLE_INBOXES';
const ADD_INBOX = 'ADD_AI_INBOX';
const REMOVE_INBOX = 'REMOVE_AI_INBOX';
const UPDATE_INBOX = 'UPDATE_AI_INBOX';
const SET_UI_FLAG = 'SET_AI_INBOXES_UI_FLAG';

export default {
  namespaced: true,
  state: {
    inboxes: [],
    availableInboxes: [],
    uiFlags: {
      fetchingList: false,
      fetchingAvailable: false,
      connecting: false,
      disconnecting: false,
      updating: false,
    },
  },
  getters: {
    getInboxes: state => state.inboxes,
    getAvailableInboxes: state => state.availableInboxes,
    getUIFlags: state => state.uiFlags,
    getInboxById: state => id =>
      state.inboxes.find(inbox => inbox.id === Number(id)) || {},
  },
  mutations: {
    [SET_UI_FLAG](state, data) {
      state.uiFlags = { ...state.uiFlags, ...data };
    },
    [SET_INBOXES](state, inboxes) {
      state.inboxes = inboxes;
    },
    [SET_AVAILABLE_INBOXES](state, inboxes) {
      state.availableInboxes = inboxes;
    },
    [ADD_INBOX](state, inbox) {
      state.inboxes.push(inbox);
      state.availableInboxes = state.availableInboxes.filter(
        i => i.id !== inbox.inbox_id
      );
    },
    [REMOVE_INBOX](state, connectionId) {
      const inbox = state.inboxes.find(i => i.id === connectionId);
      if (inbox) {
        state.availableInboxes.push(inbox.inbox);
      }
      state.inboxes = state.inboxes.filter(i => i.id !== connectionId);
    },
    [UPDATE_INBOX](state, updatedInbox) {
      const index = state.inboxes.findIndex(i => i.id === updatedInbox.id);
      if (index !== -1) {
        state.inboxes.splice(index, 1, updatedInbox);
      }
    },
  },
  actions: {
    async get({ commit }, { agentId }) {
      commit(SET_UI_FLAG, { fetchingList: true });
      try {
        const response = await AgentsAPI.getInboxes(agentId);
        const payload = response.data.payload || response.data || [];
        commit(SET_INBOXES, payload);
        return payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { fetchingList: false });
      }
    },
    async getAvailable({ commit }, { agentId }) {
      commit(SET_UI_FLAG, { fetchingAvailable: true });
      try {
        const response = await AgentsAPI.getAvailableInboxes(agentId);
        const payload = response.data.payload || response.data || [];
        commit(SET_AVAILABLE_INBOXES, payload);
        return payload;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { fetchingAvailable: false });
      }
    },
    async connect({ commit }, { agentId, inboxId, config = {} }) {
      commit(SET_UI_FLAG, { connecting: true });
      try {
        const response = await AgentsAPI.connectInbox(agentId, inboxId, config);
        commit(ADD_INBOX, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { connecting: false });
      }
    },
    async disconnect({ commit }, { agentId, connectionId }) {
      commit(SET_UI_FLAG, { disconnecting: true });
      try {
        await AgentsAPI.disconnectInbox(agentId, connectionId);
        commit(REMOVE_INBOX, connectionId);
        return connectionId;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { disconnecting: false });
      }
    },
    async update({ commit }, { agentId, connectionId, data }) {
      commit(SET_UI_FLAG, { updating: true });
      try {
        const response = await AgentsAPI.updateInboxConnection(
          agentId,
          connectionId,
          data
        );
        commit(UPDATE_INBOX, response.data);
        return response.data;
      } catch (error) {
        return throwErrorMessage(error);
      } finally {
        commit(SET_UI_FLAG, { updating: false });
      }
    },
  },
};
